var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-716.715 -619)",
    clipPath: "url(#link_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.619 640.042a5.239 5.239 0 007.9.566l3.143-3.143a5.238 5.238 0 10-7.408-7.408l-1.8 1.792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.81 637.947a5.239 5.239 0 00-7.9-.566l-3.144 3.144a5.238 5.238 0 107.408 7.408l1.791-1.792"
  })))));
}
export default SvgLink;